'use client'

import { useMemo, useState } from 'react'
import { ToolField, ToolResultCard, ToolResultRow, toolCurrency, toolFmt, toolNum } from './tool-inputs'

// Segmental retaining-wall blocks, sized by their face (length × height). 5% waste
// for cuts and breakage; base course allowance in gravel.
export function RetainingWallCalculatorTool() {
  const [length, setLength] = useState('10')
  const [height, setHeight] = useState('1')
  const [faceLen, setFaceLen] = useState('300')
  const [blockHeight, setBlockHeight] = useState('200')
  const [price, setPrice] = useState('45')

  const r = useMemo(() => {
    const wallArea = toolNum(length) * toolNum(height)
    const blockFace = (toolNum(faceLen) / 1000) * (toolNum(blockHeight) / 1000)
    const blocks = blockFace > 0 ? Math.ceil((wallArea / blockFace) * 1.05) : 0
    const courses = toolNum(blockHeight) > 0 ? Math.ceil((toolNum(height) * 1000) / toolNum(blockHeight)) : 0
    return { wallArea, blocks, courses, cost: blocks * toolNum(price) }
  }, [length, height, faceLen, blockHeight, price])

  return (
    <div className="grid gap-6 md:grid-cols-[1fr_380px] md:items-start">
      <div className="space-y-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Wall</h2>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <ToolField label="Wall length" value={length} onChange={setLength} unit="m" />
            <ToolField label="Wall height" value={height} onChange={setHeight} unit="m" step="0.1" />
          </div>
        </div>
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Block &amp; price</h2>
          <div className="mt-3 grid grid-cols-3 gap-3">
            <ToolField label="Block face" value={faceLen} onChange={setFaceLen} unit="mm" step="10" hint="length" />
            <ToolField label="Block height" value={blockHeight} onChange={setBlockHeight} unit="mm" step="10" />
            <ToolField label="Price" value={price} onChange={setPrice} unit="R/block" step="0.5" />
          </div>
        </div>
      </div>

      <ToolResultCard title="Your retaining wall estimate">
        <ToolResultRow label="Wall face area" value={`${toolFmt(r.wallArea, 1)} m²`} />
        <ToolResultRow label="Courses (rows)" value={`${r.courses} courses`} />
        <ToolResultRow label="Blocks to buy (incl. waste)" value={`${r.blocks.toLocaleString('en-ZA')} blocks`} />
        <ToolResultRow label="Estimated block cost" value={toolCurrency(r.cost)} strong />
      </ToolResultCard>
    </div>
  )
}
